module.exports = __webpack_public_path__ + "static/media/EmptyInventory.7412e024.png";